import React from 'react';

import FitmentCantFindAlternateShopOptions from '../fitment-by-vehicle/components/fitment-cant-find-alternate-shop-options/fitment-cant-find-alternate-shop-options';
import Image from '../../../image/image';
import Typography from '../../../typography/typography';
import { TabOption } from '../../fitment-types';

import './fitment-tire-size-help-guide.scss';

interface FitmentTireSizeHelpGuideProps {
  className?: string;
  onShopByClick?: (tab: TabOption) => void;
  showICantFindSizeOption?: boolean;
}
function FitmentTireSizeHelpGuide(props: FitmentTireSizeHelpGuideProps) {
  const {
    className = '',
    onShopByClick = () => {},
    showICantFindSizeOption = false
  } = props;

  return (
    <div
      className={`${className} fitment-tire-size-help-guide__container`}
      styleName="container"
    >
      <div className="fitment-tire-size-help-guide__row" styleName="row">
        <Typography styleName="content">
          There are two places to find your tire size: on the{'\u00A0'}
          <span styleName="text">
            side of the tire itself or on a sticker on the driver’s side door
            jamb.
          </span>
          The sticker on the door jamb will detail your vehicle’s original
          equipment tire size and if it has staggered tires.
        </Typography>
        <div styleName="tire-details">
          <Typography size="small" weight="heavy">
            Passenger Tire:
          </Typography>
          <Image
            alt="Tire details example"
            src="https://discounttire.scene7.com/is/image/discounttire/tire-sidewall-size-diagram?resMode=bilin&wid=400"
          />
        </div>
        <div styleName="inside-door-example">
          <Typography size="small" styleName="title" weight="heavy">
            Tire Placard: Inside front door jamb
          </Typography>
          <Image
            alt="Inside door jamb example"
            src="https://discounttire.scene7.com/is/content/discounttire/discounttire/fitment/tire-info-door-placard.svg"
          />
        </div>
        <Typography styleName="content">
          For your safety, Discount Tire will only install tires with a load
          index equal to or greater to the information on your tire placard.
        </Typography>
        {showICantFindSizeOption && (
          <>
            <div styleName="divider-container">
              <hr styleName="divider-line" />
              <span styleName="divider-text">OR</span>
              <hr styleName="divider-line" />
            </div>
            <div styleName="shop-search-button-group">
              <FitmentCantFindAlternateShopOptions
                className="search-button-group custom-width"
                onShopByClick={onShopByClick}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default FitmentTireSizeHelpGuide;
